// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Address } from './address';
import { Admin } from './admin';
import { DocumentRecipient } from './document-recipient';
import { MeetingAttendance } from './meeting-attendance';
import { ShareHolderNumber } from './share-holder-number';
import { ShareholderDividend } from './shareholder-dividend';
import { Shareholding } from './shareholding';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Shareholder extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  shareholderId!: number;
  accountName?: string;
  accountNo?: string;
  addressId!: number;
  adminId!: number;
  bsb?: string;
  createdBy!: string;
  createdDate!: Date;
  firstName?: string;
  isIndividual!: boolean;
  lastName?: string;
  mailToParent!: boolean;
  shareholderName?: string;
  title?: string;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webFlags?: number;
  address!: Address;
  admin!: Admin;
  documentRecipients!: DocumentRecipient[];
  meetingAttendances!: MeetingAttendance[];
  shareHolderNumbers!: ShareHolderNumber[];
  shareholderDividends!: ShareholderDividend[];
  shareholdings!: Shareholding[];
}

